module.exports = __webpack_public_path__ + "static/img/products_roof.568653a9.jpg";